import { DateTime } from 'luxon'
const $dateDiff = function (start = '', end = '') {
  return DateTime.fromISO(end).diff(DateTime.fromISO(start), 'days').days
}
let dateDiff = {
  install: (app, options) => {
    app.config.globalProperties.$dateDiff = $dateDiff
    app.provide('dateDiff', $dateDiff)
  }
}

export default dateDiff
